import React, { useEffect } from "react";
import styles from "./LeftPanelLayout.module.scss";
import SidebarMenu from "./SidebarMenu";
import { LeftPanelLayoutProps } from "./types";
import usePublicData from "../../hooks/usePublicData";

const LeftPanelLayout: React.FC<LeftPanelLayoutProps> = ({ children }) => {
  const { fetchPublicData } = usePublicData();

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPublicData();
    }, 1000); // Delay fetching public data by 1 second
    return () => clearTimeout(timer); // Cleanup the timer on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <SidebarMenu />
      </aside>
      <main className={styles.content}>{children}</main>
    </div>
  );
};

export default LeftPanelLayout;
